var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['meal-status-set-item', { 'meal-status-set-item--is-active': _vm.isActive }],style:({ backgroundColor: _vm.backgroundColor })},[_c('i',{class:`fas fa-${_vm.getStatusIconName(_vm.status)} meal-status-set-item__icon`}),_c('span',{staticClass:"meal-status-set-item__name"},[_vm._v(_vm._s(_vm.getStatusName(_vm.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }